const enum StoreVoActionType {
  SET_STORE_VO_UUID = 'SET_STORE_VO_UUID',
  SET_STORE_VO_NAME = 'SET_STORE_VO_NAME',
  SET_STORE_VO_DISPLAYNAME = 'SET_STORE_VO_DISPLAYNAME',
  SET_STORE_VO_IDENTIFIER = 'SET_STORE_VO_IDENTIFIER',
  SET_STORE_VO_BRAND_IMG_URL = 'SET_STORE_VO_BRAND_IMG_URL',
  SET_STORE_VO_START = 'SET_STORE_VO_START',
  SET_STORE_VO_END = 'SET_STORE_VO_END',
  SET_STORE_VO_PHONE = 'SET_STORE_VO_PHONE',
  SET_STORE_VO_ADDRESS = 'SET_STORE_VO_ADDRESS',
  SET_STORE_VO_LOCALES = 'SET_STORE_VO_LOCALES',
  SET_STORE_VO_FB = 'SET_STORE_VO_FB',
  SET_STORE_VO_LINE = 'SET_STORE_VO_LINE',
  SET_STORE_VO_COUPON_ENABLE = 'SET_STORE_VO_COUPON_ENABLE',
  SET_STORE_VO_ROYALTY_ENABLE = 'SET_STORE_VO_ROYALTY_ENABLE',
  SET_STORE_VO_PAY_METHODS = 'SET_STORE_VO_PAY_METHODS',
  SET_STORE_VO_CURRENCY = 'SET_STORE_VO_CURRENCY',
  SET_STORE_VO_ROUNDING_SCALE = 'SET_STORE_VO_ROUNDING_SCALE',
  SET_STORE_VO_PREORDERTIME_MAP = 'SET_STORE_VO_PREORDERTIME_MAP',
  SET_STORE_VO_WEB_UI_CONFIG = 'SET_STORE_VO_WEB_UI_CONFIG',
  SET_STORE_VO_WEB_GENERIC_RULES = 'SET_STORE_VO_WEB_GENERIC_RULES',
  SET_STORE_VO_SHAREMEAL_CONDITIONS = 'SET_STORE_VO_SHAREMEAL_CONDITIONS',
  SET_STORE_VO_IS_OTP_ENABLE = 'SET_STORE_VO_IS_OTP_ENABLE',
  SET_STORE_VO_TRADING_LOCATIONS = 'SET_STORE_VO_TRADING_LOCATIONS',
  SET_STORE_VO_TAKEOUT_KITCHEN_RECEIPT = 'SET_STORE_VO_TAKEOUT_KITCHEN_RECEIPT',
  SET_STORE_VO_AVAILABLE_SERVETYPES = 'SET_STORE_VO_AVAILABLE_SERVETYPES',
  SET_STORE_VO_IS_QUANTITY_EDIT_ENABLED = 'SET_STORE_VO_IS_QUANTITY_EDIT_ENABLED',
}

export { StoreVoActionType };
